import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import moment from "moment";

import membersService from "@services/members.service";
import {
  CASE_STATUS_REASON_REMINDER,
  MEMBERS_DETAILS_SCREEN_TITLE,
  MEMBERS_SCREEN_TITLE,
  MEMBER_DETAILS_LOCAL,
  MEMBER_LIST_GLOBAL,
  UPCOMING,
  USER_ACTION_DESCRIPTION_REMINDER_DELETE,
  USER_ACTION_DESCRIPTION_REMINDER_SAVE,
  USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
} from "@utils/constants";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { usePatientData } from "@utils/customHooks";
import { cloneDeep, find, flatMap, forEach, get, groupBy, noop, sortBy, uniqBy } from "lodash";
import { DAY, MONTH, WEEK, getUserActionParams, lazyLoadingRemindersLimit } from "./constant";
import { useMembersContext } from "@pages/members/useMembers";
import { localToUTCFormatDate, milleniumClientCheck } from "@utils/helpers";
import { CURRENT_ITEM } from "@components/reminder/constants";
import { useMemberListStore } from "@stores/useMemberListStore";
import { useCadenceContext } from "@components/drawerOutreaches/useCadence";

export type TReminder = {
  reminderId: string;
  reminder: string;
  reminderStartDate: string;
  reminderEndDate: string;
  patientId: string;
  recurrence: any;
  reminderStatus: any;
  patientName?: string;
  reminderTitle: string;
};

export type UseRemindersProps = {};

export type UseReminders = (props: UseRemindersProps) => {
  upcomingReminders: any;
  KPIreminderData: any[];
  futureReminderLoader: boolean;
  currentScreen: string;
  viewType: string;
  handleViewTypeChange: (viewType: string) => void;
  selectDate: any;
  filteredDates: any;
  setSelectDate: (date: any) => void;
  getReminderDates: (date?: any) => void;
  fetchFirstCurrentAndUpcomingReminders: () => void;
  fetchCurrentAndUpcomingReminders: (nextPage: number) => void;
  getReminderDataForKPI: () => void;
  getReminders: (date?: any, callBack?: any) => void;
  globalLoader: boolean;
  setGlobalLoader: (x: boolean) => void;
  todaysReminder: TReminder[];
  setTodaysReminder: (x: TReminder[]) => void;
  isReminderPopupVisible: boolean;
  setIsReminderPopupVisible: (x: boolean) => void;
  reminderToBeEdited: any;
  setReminderToBeEdited: (x: any) => void;
  dayReminders: any;
  setDayReminders: (x: any) => void;
  weekReminders: any;
  setWeekReminders: (x: any) => void;
  monthReminders: any;
  setMonthReminders: (x: any) => void;
  groupRemindersByDates: (x: any) => void;
  editReminderHandler: (reminder: any, callBack: any, members: any, updateMembers: any, updateStatus: any) => void;
  addReminderHandler: (props: any) => void;
  deleteReminderHandler: ({reminder, loaderCallback,operationRange,members, updateMembers, updateStatus } : any) => void;
  holidayList: any[];
  getTimeZoneInfo: any;
  fetchRemindersBasedOnView : (x : {view ?: string , dateRange ?: any}) => void;
};

export const useReminders: UseReminders = function (props) {
  const [KPIreminderData, setKPIreminderData] = useState<any>([]);
  const [futureReminderLoader, setFutureReminderLoader] = useState<any>(false);
  const [upcomingReminders, setUpComingReminders] = useState<any>({});
  const lazyLoadingReferenceDateTime = moment();
  const [viewType, setViewType] = useState(DAY);
  const [selectDate, setSelectDate] = useState<any>(moment());
  const [filteredDates, setFilteredDates] = useState<any>([]);
  const [globalLoader, setGlobalLoader] = useState(false);
  const [todaysReminder, setTodaysReminder] = useState<TReminder[]>([]);
  const [isReminderPopupVisible, setIsReminderPopupVisible] = useState<boolean>(false);
  const [reminderToBeEdited, setReminderToBeEdited] = useState<any>(null);
  const [dayReminders, setDayReminders] = useState<any>({});
  const [weekReminders, setWeekReminders] = useState<any>({});
  const [monthReminders, setMonthReminders] = useState<any>({});
  const holidayList = useMemberListStore((state) => state.holidayList);
  const setHolidayList = useMemberListStore((state) => state.setHolidayList);
  const currentScreen = useGlobalInformationStore((state) => state.currentScreen);
  const setMemberDetailGlobalReminder = useGlobalInformationStore((state) => state.setMemberDetailGlobalReminder);

  const {setcalendarCadences, calendarCadences} = useCadenceContext()

  const location = useLocation();
  const { patientId } = usePatientData();
  const UTC_TimeZoneOffset = moment().utcOffset();

  const { sidebarExpand } = useMembersContext();

  useEffect(() => {
    getHolidayList();
    setViewType(DAY);
    // setDayReminders(groupRemindersByDates(todaysReminder));
    fetchRemindersBasedOnView({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarExpand]);

  function updateCurrentViewReminders(reminders: any) {
    if (viewType === DAY) {
      setDayReminders(reminders);
    } else if (viewType === WEEK) {
      setWeekReminders(reminders);
    } else if (viewType === MONTH) {
      setMonthReminders(reminders);
    }
  }

  function groupRemindersByDates(reminders: any[]) {
    let data = groupBy(reminders, (r: any) => {
      return moment.utc(r.reminderStartDate).local().format("YYYY-MM-DD");
    });

    return data;
  }

  function handleViewTypeChange(view: string) {
    if (view !== viewType) {
      setViewType(view);
      fetchRemindersBasedOnView({view});
    }
  }

  function fetchRemindersBasedOnView({view = viewType , dateRange} : {view ?: string , dateRange ?: any}) {

    let _dateRange = dateRange || [];
     
    if (view === DAY) {
      getReminders(_dateRange, (dayReminders: any[], cadences: any[]) => {
        setDayReminders(groupRemindersByDates(dayReminders));
        setcalendarCadences(
          {
            [view]: cadences
          }
        )
      });
    } else if (view === WEEK) {
      _dateRange = dateRange || [selectDate.clone().startOf("week"), selectDate.clone().endOf("week")];
      getReminders(_dateRange, (weekReminders: any[], cadences: any[]) => {
        setWeekReminders(groupRemindersByDates(weekReminders));
        setcalendarCadences(
          {
            [view]: cadences
          }
        )
      });
    } else if (view === MONTH) {
      _dateRange = dateRange || [selectDate.clone().startOf("month"), selectDate.clone().endOf("month")];
      getReminders(_dateRange, (monthReminders: any[], cadences: any[]) => {
        setMonthReminders(groupRemindersByDates(monthReminders));
        setcalendarCadences(
          {
            [view]: cadences
          }
        )
      });
    }
  }

  // API calls to fetch Reminder Drawer related data

  // Fetching reminders statistic for past 30 days
  function getReminderDataForKPI() {
    setFutureReminderLoader(true);
    const isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
    let memberId = location.pathname === "/member-detail" ? patientId : undefined;
    const fromDate = moment.utc(moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).utc());
    const toDate = moment.utc(
      moment(`${moment().format("YYYY-MM-DD")} 00:00:00`)
        .subtract(30, "days")
        .utc()
    );
    membersService.getReminderStatistics(isAllCM, fromDate, toDate, memberId).subscribe({
      next: (res: any) => {
        setFutureReminderLoader(false);
        setKPIreminderData(res?.data?.data?.reminderStatistics?.statistics);
      },
      error: (err) => {
        setFutureReminderLoader(false);
        console.log(err);
      },
    });
  }

  // Fetching First n records for upcoming reminders ( data is fetching based on datetime of drawer is opened)
  function fetchFirstCurrentAndUpcomingReminders() {
    setFutureReminderLoader(true);
    const isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
    let memberId = location.pathname === "/member-detail" ? patientId : undefined;
    const fromDate = moment.utc(moment(lazyLoadingReferenceDateTime).utc());
    membersService.getPastAndFutureReminder(isAllCM, memberId, 1, lazyLoadingRemindersLimit, fromDate, UPCOMING).subscribe({
      next: (res: any) => {
        setFutureReminderLoader(false);
        // console.log(res.data.data);
        setUpComingReminders(res.data.data);
      },
      error: (err) => {
        setFutureReminderLoader(false);
        console.log(err);
      },
    });
  }

  // Fetching upcoming reminders on scroll ( lazy loading )
  function fetchCurrentAndUpcomingReminders(nextPage: number) {
    setFutureReminderLoader(true);
    const isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
    let memberId = location.pathname === "/member-detail" ? patientId : undefined;
    const fromDate = moment.utc(moment(lazyLoadingReferenceDateTime).utc());
    membersService.getPastAndFutureReminder(isAllCM, memberId, nextPage, lazyLoadingRemindersLimit, fromDate, UPCOMING).subscribe({
      next: (res: any) => {
        const upComingRemindersArray = uniqBy([...upcomingReminders?.currentAndfutureReminders, ...res.data.data?.currentAndfutureReminders], "reminderId").sort((a: any, b: any) =>
          moment(a?.reminderStartDate) < moment(b?.reminderStartDate) ? -1 : 1
        );
        setUpComingReminders({
          ...upcomingReminders,
          currentAndfutureReminders: upComingRemindersArray,
          totalFutureReminders: res.data.data?.totalFutureReminders,
        });
        setFutureReminderLoader(false);
      },
      error: (err) => {
        setFutureReminderLoader(false);
        console.log(err);
      },
    });
  }

  // Fetching Reminders occurrences on each days of the month
  function getReminderDates(date?: any) {
    const momentObj = date ? date.clone() : selectDate.clone();
    const fromDate: any = moment.utc(moment(`${momentObj.startOf("month").format("YYYY-MM-DD")} 00:00:00`).utc());
    const toDate: any = moment.utc(moment(`${momentObj.endOf("month").format("YYYY-MM-DD")} 00:00:00`).utc());
    const isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
    let memberId = location.pathname === "/member-detail" ? patientId : undefined;
    membersService.getReminderDates(isAllCM, memberId, fromDate, toDate, UTC_TimeZoneOffset).subscribe({
      next: (res: any) => {
        const result = res?.data?.data?.data;
        setFilteredDates(result?.map((rem: any) => `${moment(rem?.date).startOf("day").unix()}-${moment(rem?.date).endOf("day").unix()}`));
      },
      error: (err) => {},
    });
  }

  // Fetching reminders based on dates
  function getReminders(date?: any, callBack?: any) {
    console.log("DrawerCalendar.getAllReminders");
    setGlobalLoader(true);
    const isAllCM = currentScreen === MEMBERS_DETAILS_SCREEN_TITLE;
    let memberId = location.pathname === "/member-detail" ? patientId : undefined;
    let fromDate;
    let toDate;
    fromDate = moment.utc(moment(`${moment(get(date, "[0]") ? get(date, "[0]") : selectDate).format("YYYY-MM-DD")} 00:00:00`).utc());
    toDate = moment.utc(moment(`${moment(get(date, "[1]") ? get(date, "[1]") : selectDate).format("YYYY-MM-DD")} 23:59:59`).utc());
    membersService.getReminderData(isAllCM, fromDate, toDate, memberId).subscribe({
      next: (res) => {
        setGlobalLoader(false);
        setMemberDetailGlobalReminder(res?.data?.data?.reminders);
        setTodaysReminder(res?.data?.data?.reminders);
        if (callBack) {
          callBack(res?.data?.data?.reminders, res?.data?.data?.cadences);
        }
      },
      error: (err) => {
        setGlobalLoader(false);
        setMemberDetailGlobalReminder([]);
        setTodaysReminder([]);
      },
    });
  }

  function getCurrentViewReminderData() {
    let reminders: any = {};

    if (viewType === DAY) {
      reminders = cloneDeep(dayReminders);
    } else if (viewType === WEEK) {
      reminders = cloneDeep(weekReminders);
    } else if (viewType === MONTH) {
      reminders = cloneDeep(monthReminders);
    }

    return reminders;
  }

  // Edit Reminder
  function editReminderHandler(reminder: any, loaderCallback: any, members: any, updateMembers: any, updateStatus: any) {
    console.log("DrawerCalendar.editReminderHandler");
    setGlobalLoader(true);
    let reminderType = "";
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        reminderType = MEMBER_LIST_GLOBAL;
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        reminderType = MEMBER_DETAILS_LOCAL;
        break;
      default:
        reminderType = "";
    }
    if (reminder?.reminderId) {
      let reminderCopy = {
        patientId: reminder.patientId,
        reminderStartDate: reminder?.reminderStartDate ? localToUTCFormatDate(reminder?.reminderStartDate) : null,
        reminderEndDate: reminder?.reminderEndDate ? localToUTCFormatDate(reminder?.reminderEndDate) : null,
        reminder: reminder?.reminder,
        reminderId: reminder?.reminderId,
        reminderType: reminderType,
        recurrence: reminder?.recurrence,
        reminderStatus: reminder?.reminderStatus,
        prevReminderStartDate: reminder?.prevReminderStartDate,
        parentReminderId: reminder.parentReminderId,
        reminderTitle: reminder?.reminderTitle,
        ...reminder,
      };
      membersService.editReminder(reminderCopy).subscribe({
        next: (res) => {
          setGlobalLoader(false);
          const updatedReminderList = res?.data?.data?.reminder?.updatedReminderList;
          const newReminderList = res?.data?.data?.reminder?.newlyCreatedReminders;
          const deletedReminderLIst = res?.data?.data?.reminder?.deactivatedReminders;

          let existingReminders: any = cloneDeep(flatMap(getCurrentViewReminderData()));

          if(updatedReminderList && updatedReminderList?.length) {
            existingReminders = existingReminders.map((item:any) => {
              let temp = cloneDeep(item);
              const findItem = find(updatedReminderList, {reminderId : item?.reminderId})
              if(findItem) {
                temp = {
                  ...temp,
                  ...findItem
                }
              }
              return temp
            });  
          }

          if(deletedReminderLIst && deletedReminderLIst?.length) {
            existingReminders = existingReminders?.filter((item:any) => !find(deletedReminderLIst, {reminderId : item?.reminderId}))
          }

          if(newReminderList && newReminderList?.length) {
            existingReminders = [...existingReminders, ...newReminderList]
          }

          let updatedReminders = sortBy(existingReminders, "reminderStartDate");

          updateCurrentViewReminders(groupRemindersByDates(updatedReminders));

          if(reminderCopy?.patientId) {
            const copy = [...members];
            const cc = copy.map((p: any) => {
              let filterReminderByPatientIdForUpdate:any = [];
              let filterReminderByPatientIdForDelete:any = [];
              let filterReminderByPatientIdForNewReminders:any = [];

              if(updatedReminderList) {
                filterReminderByPatientIdForUpdate = updatedReminderList?.filter((item:any) => item?.patientId === p?.patientId);
                if (filterReminderByPatientIdForUpdate && filterReminderByPatientIdForUpdate?.length) {
                  p.reminders = p.reminders.map((r: any) => {
                    let temp = r;
                    let foundReminder = find(filterReminderByPatientIdForUpdate, {reminderId: r.reminderId});
                    if(foundReminder) {
                      temp = {
                        ...temp,
                        ...foundReminder
                      }
                    }
                  });
                }
              }

              if(deletedReminderLIst) {
                filterReminderByPatientIdForDelete = deletedReminderLIst.filter((item:any) => item?.patientId === p?.patientId);
                if(filterReminderByPatientIdForDelete && filterReminderByPatientIdForDelete?.length) {
                  p.reminders = p.reminders?.filter((r:any) => !find(filterReminderByPatientIdForDelete, {reminderId : r?.reminderId}));
                }
              }
  
              if(newReminderList) {
                filterReminderByPatientIdForNewReminders = newReminderList.filter((item:any) => item?.patientId === p?.patientId);
                if(filterReminderByPatientIdForNewReminders && filterReminderByPatientIdForNewReminders?.length) {
                  p.reminders = [...p.reminders, ...filterReminderByPatientIdForNewReminders];
                }
              }
  
              if((filterReminderByPatientIdForUpdate && filterReminderByPatientIdForUpdate?.length ||
                filterReminderByPatientIdForDelete && filterReminderByPatientIdForDelete?.length ||
                filterReminderByPatientIdForNewReminders && filterReminderByPatientIdForNewReminders?.length)) {
                p.reminders = sortBy(p.reminders, "reminderStartDate");
                const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
                  USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
                  CASE_STATUS_REASON_REMINDER,
                  currentScreen
                );
                updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
              }
              return p;
            });
  
            if(updateMembers) {
              updateMembers([]);
              updateMembers(cc);
            }
          }
          getReminderDataForKPI();
          loaderCallback();
        },
        error: () => {
          setGlobalLoader(false);
          loaderCallback();
        },
      });
    }
  }

  // Add Reminder
  function addReminderHandler({ reminderStartDate, reminderEndDate, description, recurrence, patientId, patientName, reminderTitle, loaderCallback, members, updateMembers, updateStatus }: any) {
    console.log("DrawerCalendar.addReminderHandler");
    setGlobalLoader(true);
    let reminderType = "";
    switch (currentScreen) {
      case MEMBERS_SCREEN_TITLE:
        reminderType = MEMBER_LIST_GLOBAL;
        break;
      case MEMBERS_DETAILS_SCREEN_TITLE:
        reminderType = MEMBER_DETAILS_LOCAL;
        break;
      default:
        reminderType = "";
    }
    membersService
      .addReminder(
        patientId,
        reminderStartDate,
        reminderEndDate,
        description,
        recurrence,
        {
          reminderType,
        },
        patientName,
        reminderTitle,
      )
      .subscribe({
        next: (res) => {
          setGlobalLoader(false);

          let addedReminders = res?.data?.data.reminder;

          forEach(addedReminders, (reminder) => {
            reminder.patientName = patientName;
          });

          let existingReminders: any = flatMap(getCurrentViewReminderData());

          let updatedReminders = sortBy([...existingReminders, ...addedReminders], "reminderStartDate");

          updateCurrentViewReminders(groupRemindersByDates(updatedReminders));

          const copy = [...members];
          const cc = copy.map((p: any) => {
            if (p.patient_id === patientId) {
              p.reminders = sortBy([...p.reminders, ...addedReminders], "reminderStartDate");
              const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
                USER_ACTION_DESCRIPTION_REMINDER_SAVE,
                CASE_STATUS_REASON_REMINDER,
                currentScreen
              );
              updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
            }
            return p;
          });

          if(updateMembers) {
            updateMembers([]);
            updateMembers(cc);
          }
          getReminderDataForKPI();
          loaderCallback();
        },
        error: () => {
          loaderCallback();
          setGlobalLoader(false);
        },
      });
  }

  function deleteReminderHandler({reminder, loaderCallback, operationRange = CURRENT_ITEM , members, updateMembers, updateStatus} : any) {
    console.log("DrawerCalendar.deleteReminderHandler");
    setGlobalLoader(true);
    membersService.deleteReminder(reminder?.reminderId , reminder?.parentReminderId , reminder?.reminderStartDate , operationRange).subscribe({
      next: (res) => {
        const deletedReminders = get(res , 'data.data.deletedReminders' , []);
        setGlobalLoader(false);

        let existingReminders : any = flatMap(getCurrentViewReminderData());

        let updatedReminders : any[] = [];

        updatedReminders = existingReminders.filter((rem: any) => !deletedReminders.includes(rem.reminderId));

        updateCurrentViewReminders(groupRemindersByDates(updatedReminders));

        const copy = [...members];
        const cc = copy.map((p: any) => {
          if (p.patient_id === reminder?.patientId) {
            let copyRem : any = [...(p.reminders || [])];
            copyRem  = copyRem.filter((rem: any) => !deletedReminders.includes(rem.reminderId));
            p.reminders = copyRem;
            const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
              USER_ACTION_DESCRIPTION_REMINDER_DELETE,
              CASE_STATUS_REASON_REMINDER,
              currentScreen
            );
            updateStatus(p, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
          }
          return p;
        });

        if(updateMembers) {
          updateMembers([]);
          updateMembers(cc);
        }
        getReminderDataForKPI();
        loaderCallback();
      },
      error: (err) => {
        setGlobalLoader(false);
        loaderCallback();
      },
    });
  }

  //Service call to fetch holiday list
  function getHolidayList() {
    if (holidayList.length <= 0 && milleniumClientCheck()) {
      membersService.getHolidayList().subscribe({
        next: (res) => {
          setHolidayList(get(res, "data.data", []));
        },
        error: (err) => {
          console.log(err);
          setHolidayList([]);
        },
      });
    }
  }

  function getTimeZoneInfo() {
    return (
      <>
        <div>{moment().tz(moment.tz.guess()).format("zz")}</div>
        <div>{new Date().toLocaleDateString(undefined, { timeZoneName: "short" }).split(",")[1].trim()}</div>
      </>
    );
  }

  return {
    upcomingReminders,
    KPIreminderData,
    futureReminderLoader,
    currentScreen,
    filteredDates,
    getReminderDates,
    viewType,
    handleViewTypeChange,
    selectDate,
    setSelectDate,
    getReminderDataForKPI,
    fetchFirstCurrentAndUpcomingReminders,
    fetchCurrentAndUpcomingReminders,
    getReminders,
    globalLoader,
    setGlobalLoader,
    todaysReminder,
    setTodaysReminder,
    isReminderPopupVisible,
    setIsReminderPopupVisible,
    reminderToBeEdited,
    setReminderToBeEdited,
    dayReminders,
    setDayReminders,
    weekReminders,
    setWeekReminders,
    monthReminders,
    setMonthReminders,
    groupRemindersByDates,
    editReminderHandler,
    addReminderHandler,
    deleteReminderHandler,
    holidayList,
    getTimeZoneInfo,
    fetchRemindersBasedOnView
  };
};

export const RemindersContext = createContext<ReturnType<UseReminders>>({
  upcomingReminders: {},
  KPIreminderData: [],
  futureReminderLoader: false,
  currentScreen: "",
  viewType: DAY,
  filteredDates: [],
  globalLoader: false,
  setGlobalLoader: noop,
  todaysReminder: [],
  setTodaysReminder: noop,
  handleViewTypeChange: noop,
  getReminderDates: noop,
  selectDate: moment(),
  setSelectDate: noop,
  fetchFirstCurrentAndUpcomingReminders: noop,
  fetchCurrentAndUpcomingReminders: noop,
  getReminderDataForKPI: noop,
  getReminders: noop,
  isReminderPopupVisible: false,
  setIsReminderPopupVisible: noop,
  reminderToBeEdited: null,
  setReminderToBeEdited: noop,
  dayReminders: {},
  setDayReminders: noop,
  weekReminders: {},
  setWeekReminders: noop,
  monthReminders: {},
  setMonthReminders: noop,
  groupRemindersByDates: noop,
  editReminderHandler: noop,
  addReminderHandler: noop,
  deleteReminderHandler: noop,
  holidayList: [],
  getTimeZoneInfo: noop,
  fetchRemindersBasedOnView : noop
});

export const RemindersProvider: React.FC<UseRemindersProps> = function ({ children, ...props }) {
  const remindersValue = useReminders(props);

  return <RemindersContext.Provider value={remindersValue}>{children}</RemindersContext.Provider>;
};

export const useRemindersContext = () => useContext(RemindersContext);
